import React from "react";
import { Text } from "rizzui";
import cn from "../../lib/utils/class-name";
import MyLoader from "../loader";
import { motion } from "framer-motion";

const metricCardClasses = {
  base: "border border-muted bg-gray-0 dark:bg-gray-50",
  rounded: {
    sm: "rounded-sm",
    DEFAULT: "rounded-lg",
    lg: "rounded-xl",
    xl: "rounded-2xl",
  },
};

type MetricCardTypes = {
  title: string;
  isLoading?: boolean;
  metric: React.ReactNode;
  icon?: React.ReactNode;
  iconClassName?: string;
  contentClassName?: string;
  chart?: React.ReactNode;
  info?: React.ReactNode;
  rounded?: keyof typeof metricCardClasses.rounded;
  titleClassName?: string;
  metricClassName?: string;
  chartClassName?: string;
  className?: string;
};

export default function MetricCard({
  title,
  metric,
  icon,
  chart,
  info,
  rounded = "DEFAULT",
  className,
  iconClassName,
  contentClassName,
  titleClassName,
  metricClassName,
  chartClassName,
  isLoading,
  children,
}: React.PropsWithChildren<MetricCardTypes>) {
  return (
    <div
      className={cn(
        metricCardClasses.base,
        metricCardClasses.rounded[rounded],
        className
      )}
    >
      {isLoading && <MyLoader />}
      {!isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              {icon ? (
                <div
                  className={cn(
                    "flex h-11 w-11 items-center justify-center rounded-lg bg-gray-100 lg:h-12 lg:w-12",
                    iconClassName
                  )}
                >
                  {icon}
                </div>
              ) : null}

              <div className={cn(icon && "ps-3", contentClassName)}>
                <Text className={cn(titleClassName)}>{title}</Text>
                <Text className={cn(metricClassName)}>{metric}</Text>

                {info ? info : null}
              </div>
            </div>

            {chart ? (
              <div className={cn("h-12 w-20", chartClassName)}>{chart}</div>
            ) : null}
          </div>

          {children}
        </motion.div>
      )}
    </div>
  );
}
